import React from 'react';
import PropTypes from 'prop-types';
import {getAmountDifference, getSmallestDeliveryTime, getDeliveryFeeRange,} from "../comparison.resolver";
import {Translate} from "app/services/translate";

export const OurColumn = ({availableDeliveryMethods, exchange, comparisonAmounts}) => {
    const amountDifference = getAmountDifference(comparisonAmounts.our, comparisonAmounts.other);
    const deliveryTime = getSmallestDeliveryTime(availableDeliveryMethods);

    return (
        <div className="box box-our">
            <div className="our-branding">
                <span className="logo svg-logo-default"/>
            </div>
            <div className="value">
                {exchange.rate}
            </div>
            <div className="value">
                {getDeliveryFeeRange(availableDeliveryMethods)}
            </div>
            <div className="value">
                {deliveryTime ? Translate('commons_delivery_times_' + deliveryTime.toLowerCase() + '_short') : '-'}
            </div>
            <div className="value labeled">
                <div className="label">
                    {Translate('commons_recipient_receive')}:
                </div>
                <div className="value-inside">
                    {comparisonAmounts.our.toString}
                </div>
            </div>
            <div className="value">
                {amountDifference.toString}
                <span className="arrowed">
                    ▲
                </span>
            </div>
            <div className="btn-wrapper">
                <a
                    href={Translate('comparison_button_url')}
                    className="btn btn-secondary arrow-right js-registration-modal-open">
                    {Translate('comparison_button')}
                </a>
            </div>
        </div>
    )
};

OurColumn.propTypes = {
    availableDeliveryMethods: PropTypes.object,
    exchange: PropTypes.object,
    comparisonAmounts: PropTypes.object,
};
